// Generated by CoffeeScript 2.7.0
var FixedPosition;

export default FixedPosition = class FixedPosition {
  constructor(element, positionTarget) {
    this.element = element;
    this.positionTarget = positionTarget || element.offsetParent;
    this._fixedElement();
    this._bindEvents();
  }

  _fixedElement() {
    var target_offset;
    target_offset = this.__getOffsetOfTarget(this.positionTarget);
    this.offset = this.__getOffsetOfTarget(this.element, this.positionTarget);
    this.element.style.position = 'fixed';
    this.element.style.top = `${target_offset.top + this.offset.top}px`;
    this.element.style.marginTop = 0;
    this.element.style.marginLeft = 0;
    return this.element.style.left = `${target_offset.left + this.offset.left}px`;
  }

  _bindEvents() {
    var fn;
    fn = () => {
      this.__removeStyle();
      return this._fixedElement();
    };
    window.addEventListener('resize', fn, false);
    return document.addEventListener('turbolinks:before-render', function() {
      return window.removeEventListener('resize', fn, false);
    });
  }

  __removeStyle() {
    return this.element.removeAttribute('style');
  }

  __getOffsetOfTarget(element, target = document.body) {
    var offsetLeft, offsetTop;
    offsetTop = 0;
    offsetLeft = 0;
    while (element !== target) {
      offsetTop += element.offsetTop;
      offsetLeft += element.offsetLeft;
      element = element.offsetParent;
    }
    return {
      left: offsetLeft,
      top: offsetTop
    };
  }

};
